const TONES = [
  [/onboard|approv|complet|accept/i, "published"],
  [/reject|declin|cancel/i, "rejected"],
  [/pending|submit|await|new|progress/i, "submitted"],
];

function toneFor(status) {
  const text = String(status ?? "");
  const match = TONES.find(([pattern]) => pattern.test(text));
  return match ? match[1] : "archived";
}

export function RequestStatusBadge({ status, className = "" }) {
  if (!status) return <span className="text-[12px] per-file-hint">—</span>;

  const tone = toneFor(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold ${className}`}
      style={{
        backgroundColor: `var(--status-${tone}-bg)`,
        color: `var(--status-${tone}-fg)`,
      }}
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: `var(--status-${tone}-dot)` }}
      />
      {String(status).replace(/[_-]+/g, " ")}
    </span>
  );
}

/** "17 Sep 2026" — the day alone, for where the hour adds nothing. */
export function formatRequestDay(value, t) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const months = [
    "dateTime.monthJan", "dateTime.monthFeb", "dateTime.monthMar", "dateTime.monthApr",
    "dateTime.monthMay", "dateTime.monthJun", "dateTime.monthJul", "dateTime.monthAug",
    "dateTime.monthSep", "dateTime.monthOct", "dateTime.monthNov", "dateTime.monthDec",
  ];
  return `${String(date.getDate()).padStart(2, "0")} ${t(months[date.getMonth()])} ${date.getFullYear()}`;
}

/** "17 Sep 2026, 15:40" — the same stamp format the rest of the app uses. */
export function formatRequestDate(value, t) {
  const day = formatRequestDay(value, t);
  if (!day) return "";
  const date = new Date(value);
  const pad = (part) => String(part).padStart(2, "0");
  return `${day}, ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export default RequestStatusBadge;
